import { ContainerInternoProps } from './styles';

const ContainerInterno = ({ children }) => {
  return <ContainerInternoProps>{children}</ContainerInternoProps>;
};

export default ContainerInterno;
